import Vue from 'vue'
export const globalEvents = new Vue()
